/* eslint-disable import/prefer-default-export */
import Tracking from '@/components/commons/Tracking';
import { throttle } from '@/components/commons/MiniLodash';

let trackedReviews = [];

function track() {
  if (trackedReviews && trackedReviews.length) {
    Tracking.track('Reviews Viewed', { 'Review Ids': trackedReviews.join(',') });
    trackedReviews = [];
  }
}

const throttledTrack = throttle(track, 5000);

export function trackReviewViewed(review) {
  if (review && review.productReviewId) {
    trackedReviews.push(review.productReviewId);
  }
  throttledTrack();
}
